import { cn } from '@/utils/classnames';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-[#E1E7F0] dark:bg-[#17233A]", className)}
      {...props}
    />
  )
}

export { Skeleton }
